import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static override targets = [ "dialog", "pageContext" ]

  declare readonly dialogTarget: HTMLDialogElement
  declare readonly hasPageContextTarget: boolean
  declare readonly pageContextTarget: HTMLInputElement

  open() {
    if (this.hasPageContextTarget) {
      this.pageContextTarget.value = window.location.href
    }
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
    // Optional: clear the modal content after closing
    const frame = this.dialogTarget.querySelector("turbo-frame");
    if (frame) {
      frame.innerHTML = "";
    }
  }

  // Close when clicking the backdrop
  closeOnBackdropClick(event: Event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }

  // Close on form submission success
  closeOnSubmit(event: CustomEvent) {
    if (event.detail.success) {
      this.close()
    }
  }
} 